import {inject} from "vue";
import type {Axios} from "axios";
import type {Auth} from "@/auth/oauth";

function mustInject<T>(key: string): T {
  const result = inject<T>(key);
  if (result === undefined) {
    throw new Error(`Could not inject: ${key}`);
  }

  return result;
}

export function injectAxios(): Axios {
  return mustInject<Axios>("axios");
}

export function injectAuth(): Auth {
  return mustInject<Auth>("auth");
}
